import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Pump } from '../shared/models/Pump';
import { PUMP_URL } from '../shared/constats/urls';

@Injectable({
  providedIn: 'root'
})
export class PumpService {

  constructor(private http: HttpClient, private toastrService: ToastrService,) { }

  savePump(pump: Pump): Observable<any> {
    return this.http.post(PUMP_URL + '/', pump).pipe(
      catchError((error) => {
        this.toastrService.error('Error al asociar tanque ', 'Error');
        throw error;
      }),
      tap(() => {
        this.toastrService.success('Tanque asociado con éxito', 'Éxito');
      })
    );
  }

  editPump(id: String, pump: Pump): Observable<any> {
    return this.http.put(PUMP_URL + '/' + id, pump);
  }


  getPump(): Observable<Pump> {
    return this.http.get<Pump>(PUMP_URL);
  }

  deletePump(id: String): Observable<any> {
    return this.http.delete(PUMP_URL + '/' + id);
  }

}
